/**
 * Modos de edición del componente para el detalle de la región
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
enum RegionDetailMode {
    None = 'none',
    Editing = 'editing',
    Creating = 'creating',
}

export default RegionDetailMode
